import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ChatMessage } from './types';
import { BubbleRow, Bubble, BubbleTimestamp } from './AiChat.styles';

interface AiChatMessageProps {
    message: ChatMessage;
}

function formatTime(date: Date): string {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

const AiChatMessage: React.FC<AiChatMessageProps> = ({ message }) => {
    const isUser = message.role === 'user';

    return (
        <BubbleRow $isUser={isUser}>
            <div>
                <Bubble $isUser={isUser}>{isUser ? message.content : <Markdown remarkPlugins={[remarkGfm]}>{message.content}</Markdown>}</Bubble>
                <BubbleTimestamp $isUser={isUser}>{formatTime(message.timestamp)}</BubbleTimestamp>
            </div>
        </BubbleRow>
    );
};

export default React.memo(AiChatMessage);
